import React, {Component} from 'react'

import clearSvg from "manager/../images/clear-x.svg"
import mapMarkerSvg from "manager/../images/map-marker.svg"
import infoSvg from "manager/../images/info-question-mark.svg"
import styled from "styled-components"
import {DESKTOP_BREAKPOINT} from "manager/views/components/Settlement/constants"
import {connect} from "react-redux"
import {createStructuredSelector} from "reselect"
import {selectSearchConfig, selectSearchNameFilter} from "manager/selectors/settlement_provider_search_selectors"
import {setSettlementProviderSearchNameFilter} from "manager/redux/settlement_provider_search"
import {SettlementCard} from "manager/views/components/Settlement/Common/SettlementCard"
import {selectAgentOpId, selectTransactionOpId} from "manager/selectors/referral_selectors"
import {segmentEventTracker} from "common/analytics"

const SearchCriteriaComponent = styled(SettlementCard)`
  .fa-question-circle {
    color: #B4B3B3;
    cursor: pointer;
  }

  .fa-map-marker {
    font-size: 20px;
  }
`

const Headline = styled.div`
  font-weight: bold;
  font-size: 26px;
  line-height: 33px;
  padding-top: 15px;
  padding-bottom: 12px;
`

const SearchCriteriaContainer = styled.div`
  margin-top: 16px;
  @media screen and ${DESKTOP_BREAKPOINT} {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
  }
`

const SearchCriterion = styled.div`
  padding-bottom: 20px;
`

const OriginAddress = styled.div`
  display: flex;
  margin-top: 15px;
  margin-bottom: 12px;

  > div {
    margin-right: 10px;
  }
`

const NameSearchCriterion = styled(SearchCriterion)`
  @media screen and ${DESKTOP_BREAKPOINT} {
    margin-left: 36px;
    
    > .prompt {
      width: 22em;
    }
  }
`

const ProviderNameFilterContainer = styled.div`
  margin-top: 20px;
  border: 1px solid #CCCCCC;
  border-radius: 4px;
  display: flex;
  align-items: center;
  width: 100%

  @media screen and ${DESKTOP_BREAKPOINT} {
    width: 22em;
  }
`

const ProviderNameFilter = styled.input`
  margin: 0 4px;
  padding: 10px 8px;
  outline: none;
  width: 100%;
  border: none;
`

const MapMarkerIcon = styled.div`
  background-image: url(${mapMarkerSvg});
  background-size: cover;
  width: 12px;
  height: 16px;
  margin-top: 2px;
`

const InfoIcon = styled.div`
  background-image: url(${infoSvg});
  background-size: cover;
  width: 16px;
  height: 16px;
  cursor: pointer;
  display: inline-block;
  margin-top: 3px;
  margin-left: 4px;
  flex-shrink: 0;
`

const ClearIcon = styled.div`
  background-image: url(${clearSvg});
  background-size: cover;
  width: 16px;
  height: 17px;
  flex: 0 0 16px;
  cursor: pointer;
  margin-right: 15px;
`


class ProviderSearchCriteria extends Component {
  componentDidMount() {
    const {transaction_op_id, agent_op_id} = this.props
    if (transaction_op_id && agent_op_id) {
      segmentEventTracker("New-Settlement-Provider Viewed", {'transaction_op_id': transaction_op_id, 'agent_op_id': agent_op_id})
    }
  }
  showUpdateAddressView = () => {
    this.props.setUpdateAddressView(true)
  }

  showMoreInfo = () => {
    this.props.setShowMoreInfo(true)
  }

  updateNameFilter = async (event) => {
    const nameFilter = event && event.target && event.target.value

    if (nameFilter !== undefined) {
      const {onChange, dispatch} = this.props
      await dispatch(setSettlementProviderSearchNameFilter(nameFilter))
      onChange()
    }
  }

  clearNameFilter = async () => {
    const {onChange, dispatch} = this.props
      await dispatch(setSettlementProviderSearchNameFilter(null))
      onChange()
  }

  render() {
    const {searchConfig: config, nameFilter} = this.props

    if (!config) { return null }

    return (
      <SearchCriteriaComponent paddingRight='83px' marginTop='0px'>
        <Headline>Select a Provider</Headline>
        <div>
          <span>Choose a digital-powered title company to track the closing process in real time, automate your status updates to close, and more.</span><InfoIcon onClick={this.showMoreInfo}/>
        </div>
        <SearchCriteriaContainer>
          <SearchCriterion>
            <div>Show digital close providers near:</div>
            <OriginAddress>
              <MapMarkerIcon />
              <div>
                <div data-testid="origin_address_first">{config.origin_address}</div>
                <div data-testid="origin_address_second">{config.origin_city ? `${config.origin_city}, ` : ''}{config.origin_state} {config.origin_zipcode}</div>
              </div>
            </OriginAddress>
            <div><a onClick={this.showUpdateAddressView}>Not the right address?</a></div>
          </SearchCriterion>
          <NameSearchCriterion>
            <div className={"prompt"}>You can also manually enter any provider name.</div>
            <ProviderNameFilterContainer>
              <ProviderNameFilter placeholder="Provider name"
                                  data-testid="provider-name-filter"
                                  value={nameFilter}
                                  onChange={(event) => this.updateNameFilter(event)}/>
              {nameFilter && nameFilter.length > 0 && <ClearIcon onClick={this.clearNameFilter} /> }
            </ProviderNameFilterContainer>
          </NameSearchCriterion>
        </SearchCriteriaContainer>
      </SearchCriteriaComponent>
    )
  }

}

const selector = createStructuredSelector({
  searchConfig: selectSearchConfig,
  nameFilter: selectSearchNameFilter,
  transaction_op_id: selectTransactionOpId,
  agent_op_id: selectAgentOpId,
})

export default connect(selector)(ProviderSearchCriteria)
